import React from 'react';
import { ENTRY_WIDTH_UNIT } from '../../../../constants/styling/styles';

const Hours = ({ hours, marginLeft, nowButton, nowOnClick, zoom }) => (
    <ul
        className="ckp-timetable-hours"
        style={{ marginLeft: marginLeft, width: (hours.length / 2) * (ENTRY_WIDTH_UNIT * zoom) }}
    >
        {nowButton ? (
            <a onClick={nowOnClick} style={{ left: -marginLeft }} className="ckp-timetable-hours-now ckp-ts-h3">
                Now
            </a>
        ) : null}
        {hours.map((h, i) => (
            <li key={i} style={{ minWidth: (ENTRY_WIDTH_UNIT * zoom) / 2 }} className="ckp-timetable-hour">
                <span className="ckp-timetable-hour-text">{h}</span>
            </li>
        ))}
    </ul>
);

export default Hours;



// WEBPACK FOOTER //
// ./src/components/application/timetable/time/Hours.js